var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecryptAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 22 22",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st2{fill:#98a2bb}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_795",
    transform: "translate(-608 -909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_481"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 0c6.08 0 11 4.92 11 11s-4.92 11-11 11S0 17.08 0 11 4.92 0 11 0z",
    fill: "none",
    transform: "translate(608 909)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11 1C5.49 1 1 5.49 1 11s4.49 10 10 10 10-4.49 10-10S16.51 1 11 1m0-1c6.08 0 11 4.92 11 11s-4.92 11-11 11S0 17.08 0 11 4.92 0 11 0z",
    transform: "translate(608 909)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    transform: "translate(614.696 915.696)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0 3.8h8.61v1H0z",
    id: "Line_9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3.8 0h1v8.61h-1z",
    id: "Line_10"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecryptAdd);
export default __webpack_public_path__ + "static/media/recrypt_add.9108d606.svg";
export { ForwardRef as ReactComponent };